import React from 'react'
import './Proyectos.css'
import {ReactComponent as Arrow} from '../../assets/arrowRight.svg'
import {ReactComponent as Image} from '../../assets/emptyimage.svg'
import '../../components/home/ReadyOld.css'

function Proyectos() {
    return (
        <div className="proyectosWrapper">
            <ProyectosHero
                title="Proyectos."
                title2="Descubre nuestros poryectos más innovadores."
                sub="Queremos que descubras nuestras capacidades más creativas y técnicas. La creación de productos requiere de experienca, interactividad y lógica."
            />
            <div className="proyectosItemsWrapper">
                <div className="proyectosItems">
                    <ProyectosItem
                        itemA="Bubbo | "
                        itemB="La nueva plataforma de contenido interactivo."
                    />
                    <ProyectosItem
                        itemA="Bubbo | "
                        itemB="Branding, imagen de marca y universo visual."
                    />
                    <ProyectosItem
                        itemA="Dwoorks | "
                        itemB="Una agencia distinta. Tomorrow it's calling"
                    />
                    <ProyectosItem
                        itemA="Dwoorks | "
                        itemB="Carteleria in the office. #The mood rules"
                    />
                    <ProyectosItem
                        itemA="Soysho | "
                        itemB="Diseño de marca y packaging."
                    />
                    <ProyectosItem
                        itemA="Dwoorks | "
                        itemB="Digital Meeting Room. El espacio de creación."
                    />
                </div>
                    
            </div>
            <Ready style={{width:"100vw!important"}}/>
        </div>
    )
}

function ProyectosHero(props){
     return (
        <div className="proyectosHeroWrapper">
            <div className="proyectosHero">
                <div className="proyectosHeroMain">
                    <h1 className="proyectosHeroTitle">
                        {props.title}
                    </h1>
                    <h1 className="proyectosHeroSubTitle">
                        {props.title2}
                    </h1>
                </div>
                <div className="proyectosHeroSub">
                    <p className="proyectosHeroSubContent">
                        {props.sub}
                    </p>
                </div>
            </div>

        </div>
    )
} 

function ProyectosItem(props){
    return(
        <div className="proyectosItemsWrapper">
            <div className="proyectosItemImg">
                <Image/>
            </div>
            <div className="proyectosItemSub">
            <span style={{color:"#00000c", fontFamily:"PPPangramSansRounded-Bold"}}>{props.itemA}</span>{props.itemB}
            </div>
        </div>
    )
}

function Ready() {
    return (
        <div className="readySectionWrapper" style={{backgroundColor:"#FFFCEB"}}>

            <div className="readySection">
                <div className="readySectionLeft">
                    <div className="readySectionMain">
                        <h1 className="readySectionSubTitle">
                            <span className="readySectionTitle">¿Ready? </span>
                            Elige una reunión con un experto o cuentanos tu proyecto.
                        </h1>
                    </div>
                    
                    <div className="readySectionSub">
                        <p className="readySectionSubContent" >
                            Elige entre una reunión de 30 minutos con un consultor experto o cuentanos tu proyecto directamente a través del formulario. <b>Todo con la máxima confidencialidad</b>.
                        </p>
                    </div>
                </div>
                <div className="readySectionRight">
                    <div className="readyItems">
                        <div className="readyItem">
                            <h3 className="readyItemTitle">Contacta con un consultor experto para que te atienda.</h3>
                            <div className="readyItemContent">Pondremos desde el minuto 1 un consultor experto a tu disposición para que te ayude en lo que necesites.</div>
                            <p className="readyItemMore">
                                Contacta con un experto
                                <Arrow style={{marginLeft:"11.83px"}}/>
                            </p>
                        </div>
                        <div className="readyItem">
                            <h3 className="readyItemTitle">Cuentanos tu proyecto a traves del formulario de partners.</h3>
                            <div className="readyItemContent">Hemos habilitado un formulario diseñado para que nos cuentes tu proyecto. Toda la información estara protegida por un <span style={{color:"#00D563"}}>NDA*</span>.</div>
                            <p className="readyItemMore">
                                Rellenar Formulario
                                <Arrow style={{marginLeft:"11.83px"}}/>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Proyectos
